import { getCustomProps, getSubCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface ListHoliday {
  id?: string
  name: string
  countryId: string
  holidays: Holidays[]
}

export interface Holidays {
  date: string
  holidayGroupId: string
  id: string
  customFields: any
}

export async function getListHolidays(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['country_id = :countryId']
  if (search) {
    where.push(`CONCAT(name) ILIKE '%${search}%'`)
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          `ORDER BY (CASE WHEN name ~ '^[0-9]+$' THEN CAST(name AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, name ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        "ORDER BY (CASE WHEN name ~ '^[0-9]+$' THEN CAST(name AS NUMERIC) ELSE NULL END), name"
      ])
  // result
  const response: any = await getData({
    tables: ['pg_holiday_groups'],
    fields: ['id', 'name', 'updated_at', 'country_id'],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response[0]
}

export async function getListHoliday(id: string): Promise<ListHoliday> {
  const data = await getData<any>({
    tables: ['pg_holiday_groups'],
    fields: ['id', 'name', 'country_id', 'custom_fields as custom'],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createListHoliday(data: ListHoliday): Promise<boolean> {
  const response: any = await http.post('country/holiday-groups', {
    countryId: data.countryId,
    name: data.name,
    holidays: getSubCustomProps(data.holidays),
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateListHoliday(
  data: ListHoliday,
  id: string
): Promise<boolean> {
  const response: any = await http.put('country/holiday-groups/' + id, {
    countryId: data.countryId,
    name: data.name,
    holidays: getSubCustomProps(data.holidays),
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteListHoliday(id: string): Promise<boolean> {
  const response: any = await http.delete('country/holiday-groups/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
